import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_WEBHOOKS,
  GET_WEBHOOKS_SUCCESS,
  GET_WEBHOOKS_FAILED,
  CREATE_WEBHOOKS,
  CREATE_WEBHOOKS_SUCCESS,
  CREATE_WEBHOOKS_FAILED,
  UPDATE_WEBHOOKS,
  UPDATE_WEBHOOKS_SUCCESS,
  UPDATE_WEBHOOKS_FAILED,
  DELETE_WEBHOOKS,
  DELETE_WEBHOOKS_SUCCESS,
  DELETE_WEBHOOKS_FAILED,
} from './constants';

export const initialState: State = {
  webhooksList: [],
  count: 0,
  loading: false,
  error: '',
};

export const WebhooksReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_WEBHOOKS:
        draft.loading = true;
        break;
      case GET_WEBHOOKS_SUCCESS:
        draft.webhooksList = action.data;
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_WEBHOOKS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case CREATE_WEBHOOKS:
        draft.loading = true;
        break;
      case CREATE_WEBHOOKS_SUCCESS:
        draft.loading = false;
        break;
      case CREATE_WEBHOOKS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case UPDATE_WEBHOOKS:
        draft.loading = true;
        break;
      case UPDATE_WEBHOOKS_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_WEBHOOKS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case DELETE_WEBHOOKS:
        draft.loading = true;
        break;
      case DELETE_WEBHOOKS_SUCCESS:
        draft.loading = false;
        break;
      case DELETE_WEBHOOKS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
    }
  });
export default WebhooksReducer;
